module.exports = __webpack_public_path__ + "files/5b506a2cfef3dd9d2ac01220379237e9.png";